import * as React from 'react';
import Svg, { Rect, Path } from 'react-native-svg';
const Profile = (props) => (<Svg viewBox="0 0 36 36" accessibilityRole="image" {...props}>
    <Rect width={36} height={36} rx={8} fill="#E7F3FB"/>
    <Path d="M21.092 18.592a5 5 0 1 0-6.184 0 8.333 8.333 0 0 0-5.183 6.816.838.838 0 1 0 1.667.184 6.667 6.667 0 0 1 13.25 0 .833.833 0 0 0 .833.741h.092a.833.833 0 0 0 .733-.916 8.333 8.333 0 0 0-5.208-6.825ZM18 18a3.334 3.334 0 1 1 0-6.668A3.334 3.334 0 0 1 18 18Z" fill="#3999DE"/>
  </Svg>);
export default Profile;
